const NSFW_TERMS = [
  "nude", "naked", "nsfw", "porn", "porno", "xxx",
  "sex", "sexual", "intercourse", "orgasm",
  "erotic", "erotica", "sensual",
  "topless", "bottomless", "undress",
  "genitalia", "penis", "vagina", "breasts",
  "blowjob", "handjob", "anal",
  "hentai", "ecchi",
  "stripper", "striptease",
  "fetish", "bdsm", "bondage",
  "dildo", "vibrator",
  "cum", "cumshot",
  "threesome", "orgy",
  "masturbat",
  "lewd", "smut",
  "adult content", "adult only", "adults only",
  "18+",
]

const NSFW_REGEX = new RegExp(
  NSFW_TERMS.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|"),
  "i",
)

const STORAGE_KEY = "age-verified"

export function isNsfwPrompt(prompt: string): boolean {
  return NSFW_REGEX.test(prompt)
}

export function isAgeVerified(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true"
  } catch {
    return false
  }
}

export function setAgeVerified(): void {
  try {
    localStorage.setItem(STORAGE_KEY, "true")
  } catch {
    // localStorage unavailable
  }
}
